import { Chip, SelectButton, ToggleButton } from 'primereact';
import React, {useState} from "react";

export function Top5Cxc() {
  const [value, setValue] = React.useState(null);
  const items = [
    { name: "30 días", value: 1 },
    { name: "60 días", value: 2 },
    { name: "90 días", value: 3 },
    { name: "+90 días", value: 4 },
  ];

  function handleChange(value) {
    setValue(value);
    if (value === 1) {
      setTableTop5Cxc(respuesta30);
      tableTop5Cxc.show();
    } else if (value === 2) {
      setTableTop5Cxc(respuesta60);
      tableTop5Cxc.show();
    } else if (value === 3) {
      setTableTop5Cxc(respuesta90);
      tableTop5Cxc.show();
    } else if (value === 4) {
      setTableTop5Cxc(respuestaMas90);
      tableTop5Cxc.show();
    } else {
      tableTop5Cxc.hide();
    }
  }

  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectButton
          value={value}
          onChange={(e) => handleChange(e.value)}
          optionLabel="name"
          options={items}
        />
      </div>
    </React.Fragment>
  );
}